<template>
  <div>
    <v-card class="white rounded-lg">
      <v-card-title class="secondary--text">
        {{ title }}

        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-autocomplete
              @change="changeFilters"
              label="انتخاب نوع فاکتور"
              class="rounded-lg ml-3"
              :items="factorTypes"
              v-model="factorType"
              item-text="name"
              item-value="value"
          />

        </v-col>
        <v-btn
          :disabled="selectedFactors.length <= 0"
          large
          @click="openSubmitDialog()"
          depressed
          color="success"
          class="ml-1 success white--text mt-1 mt-md-0 rounded-lg"
          >
          <span v-if="selectedFactors.length > 0">
             ارسال به سامانه مودیان
          </span>
          <span v-else>
            حداقل یک فاکتور انتخاب کنید
          </span>

        </v-btn>
      </v-card-title>
      <v-card-subtitle class="info--text">
        <v-icon color="info">fa-check</v-icon>
        برای ارسال فاکتور به سامانه مودیان از سمت راست جدول فاکتور های ارسالی را انتخاب کنید
      </v-card-subtitle>
      <v-card-text>
        <m-datatable
          :headers="headers"
          :apiUrl="url"
          :filters.sync="filters"
          :show-applied-filters="true"
          :show-clear-filters-btn="true"
          ref="datatable"
          v-model="selectedFactors"
        >
          <template #item.remain="{ item }">{{ getRemain(item) | toMoney }}</template>
          <template #item.settle="{ item }">
            <v-btn depressed class="rounded-lg" color="info white--text" :to="toSettle(item)" text>تسویه</v-btn>
          </template>
          <template #item.detail="{ item }">
            <detail-link :to="to(item)" />
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>

    <!-- Submit Dialog -->
    <v-dialog v-model="submitDialog" max-width="500px">
      <v-card class="rounded-lg pa-4">
        <v-card-title class="secondary--text">تنظیمات ارسال به سامانه مودیان</v-card-title>
        <v-card-text>
          <v-autocomplete
              label="روش تسویه"
              class="rounded-lg mb-3"
              :items="peymentTypes"
              v-model="peymentType"
              item-text="name"
              item-value="value"
          />
          <v-autocomplete
              class="rounded-lg"
              label="نوع صورتحساب"
              :items="invoiceTypes"
              v-model="invoiceType"
              item-text="name"
              item-value="value"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="submitDialog = false">انصراف</v-btn>
          <v-btn color="success" @click="submit()">ارسال</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog class="rounded-lg" v-model="responseDialog" scrollable max-width="1200px" transition="dialog-transition">
      <v-card class="rounded-lg pa-2">
        <v-card-title class="secondary--text"> نتیجه ارسال فاکتور ها </v-card-title>

        <v-card-text>
          <m-datatable
              :headers="responseHeaders"
              :items="selectedFactors"
              :filters.sync="responseFilters"
              :isDialog="true"
          >
            <template #item.responseStatus="{ item }">
              <span v-if="response[item.id].success">موفق</span>
              <span v-else>ناموفق</span>
</template>

            <template #item.responseMessage="{ item }">
              {{ response[item.id].message }}
            </template>

            <template #item.detail="{ item }">
              <detail-link :to="to(item)" />
            </template>
          </m-datatable>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FactorMixin from "@/views/panel/factor/mixin";
import MoadianMixin from "@/modules/moadian/mixin";
import MDatatable from "@/components/m-datatable/MDatatable.vue"

export default {
  name: "FactorsList",
  components: {MDatatable},
  mixins: [FactorMixin, MoadianMixin],
  props: {
    type: {},
    isPreFactor: {},
  },
  data() {
    return {
      filters: {
        type: "sale",
        is_pre_factor: false,
        is_defined: true,
        is_moadian_back_factor: false,
      },
      url: "reports/lists/factors",
      selectedFactors: [],

      submitDialog: false,
      responseDialog: false,
      responseFilters: {},
      response: null,
      factorType: 'sale',
      factorTypes: [
        {name: 'فاکتور فروش', value: 'sale'},
        {name: 'فاکتور برگشت از فروش', value: 'backFromSale'},
      ],
  
      invoiceTypes: [
        {name: 'همراه با اطلاعات خریدار', value: 1},
        {name: 'بدون اطلاعات خریدار', value: 2},
      ],
      peymentTypes: [
        {name: 'نقدی', value: 1},
        {name: 'نسیه', value: 2},
      ],
      invoiceType: 1,
      peymentType: 2,
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('ارسال فاکتور فروش به سامانه مودیان')
    },
    headers() {
      let headers = [
        {
          text: "شماره",
          value: "code",
        },
        {
          text: "تاریخ",
          value: "date",
          type: "date",
        },
        {
          text: ["buy", "backFromBuy"].includes(this.type) ? "فروشنده" : "مشتری",
          value: "account.name",
        },
      ];
      if (this.type == "buy") {
        headers.push({
          text: "شماره فاکتور فروشنده ",
          value: "seller_factor_code",
        });
      }
      headers.push({
        text: "شرح",
        value: "explanation",
      });
      headers.push({
        text: "مبلغ کل فاکتور",
        value: "round_total_sum",
        type: "numeric",
      });

      if (this.type != "cw") {
        headers.push({
          text: "مالیات ",
          value: "has_tax",
          type: "boolean",
        });
      }
      headers.push({
        text: this.type == "buy" ? "پرداخت شده " : "دریافت شده",
        value: "is_settled",
        type: "boolean",
      });
      headers.push({
        text: "موضوع",
        value: "moadian_subject",
        type: "select",
        items: this.invoiceSubjects,
      });
      headers.push({
        text: "جزئیات",
        value: "detail",
        sortable: false,
        filterable: false,
      });

      return headers;
    },
    responseHeaders() {
      let headers = [
        {
          text: "شماره",
          value: "code",
        },
        {
          text: "تاریخ",
          value: "date",
          type: "date",
        },
        {
          text: ["buy", "backFromBuy"].includes(this.type) ? "فروشنده" : "مشتری",
          value: "account.name",
        },
        {
          text: "نتیجه ثبت",
          value: "responseStatus",
        },
        {
          text: "پیغام",
          value: "responseMessage",
        },
        {
          text: "جزئیات",
          value: "detail",
        },
      ];
      return headers;
    },
  },
  created() {
    this.filters.type = "sale";
    this.filters.is_pre_factor = false;
    this.filters.is_defined = true;
    this.filters.is_moadian_back_factor = false;
  },
  watch: {
    // $route() {
    //   this.filters.type = this.type;
    //   this.filters.is_pre_factor = this.isPreFactor;
    //   this.$refs.datatable.getDataFromApi();
    // },
  },
  methods: {
    openSubmitDialog() {
      if(this.selectedFactors.length > 0) {
        this.submitDialog = true;
      }
        },
    submit() {
      this.submitDialog = false;
      // if(this.selectedFactors.length == 0) {
      //   window.alert("حداقل یک فاکتور انتخاب کنید")
      //   return
      // }
  
      const factors = this.selectedFactors.map((o) => o.id);
      // const factors = [10134]

      this.request({
        url: this.endpoint("moadian/keysan/submitFactors/"),
        method: "post",
        data: {
          factors: factors,
          invoice_type: this.invoiceType,
          peyment_type: this.peymentType,
        },
        success: (data) => {
          this.response = data;
          this.responseDialog = true;

          this.$refs.datatable.getDataFromApi();
        },
      });
    },
    to(item) {
      return {
        name: "FactorForm",
        params: {
          isPreFactor: item.is_pre_factor,
          type: item.type,
          id: item.id,
        },
      };
    },
    changeFilters() {
      this.selectedFactors = [];
      if (this.factorType == 'sale') {
        this.filters.type = "sale";
        this.filters.is_pre_factor = false;
        this.filters.is_defined = true;
        this.filters.is_moadian_back_factor = false;
        this.$refs.datatable.getDataFromApi()
        console.log(this.filters)
      } else {
        this.filters.type = "backFromSale";
        this.filters.is_pre_factor = false;
        this.filters.is_defined = null;
        this.filters.is_moadian_back_factor = true;
        this.$refs.datatable.getDataFromApi()
        console.log(this.filters)
  
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
